export default __webpack_public_path__ + "media/images/elephant_ui_disappointed_sub-f097daa45f38409b7a3d1d44a04b912f.png";